var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72566 0.621948C7.72566 0.527417 7.64831 0.450073 7.55378 0.450073L6.13582 0.456519L4.00028 3.00242L1.86689 0.458668L0.446777 0.452222C0.352246 0.452222 0.274902 0.527417 0.274902 0.624097C0.274902 0.664917 0.289941 0.703589 0.315722 0.735816L3.11083 4.06589L0.315722 7.39382C0.289762 7.42531 0.275357 7.46474 0.274902 7.50554C0.274902 7.60007 0.352246 7.67742 0.446777 7.67742L1.86689 7.67097L4.00028 5.12507L6.13367 7.66882L7.55163 7.67527C7.64616 7.67527 7.72351 7.60007 7.72351 7.50339C7.72351 7.46257 7.70847 7.4239 7.68269 7.39168L4.89188 4.06375L7.68698 0.733667C7.71276 0.703589 7.72566 0.662769 7.72566 0.621948Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.4991fd54.svg";
export { ForwardRef as ReactComponent };